var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7882 6.78823L17 0L10.2118 6.78823L17 13.5765L23.7882 6.78823ZM13.6059 16.9706L6.81766 10.1823L0.0294375 16.9706L6.81766 23.7588L13.6059 16.9706ZM26.6167 9.61665L33.4049 16.4049L26.6167 23.1931L19.8284 16.4049L26.6167 9.61665ZM23.2225 26.5872L16.4343 19.799L9.64609 26.5872L16.4343 33.3754L23.2225 26.5872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.5e81c2cf.svg";
export { ForwardRef as ReactComponent };